import React, {Component} from 'react';
import Styles from './style.css';
import Header from "../../components/header/component";
import cx from "classnames";
import * as Icon from "react-feather";
import Footer from "../../components/footer/component";
import ContactForm from "../../components/contact-form/component";
import ProjectOdd from "../../components/project-odd/component";
import ProjectEqual from "../../components/project-equal/component";
import Chat from "../../components/chat/component";

class Lab extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {
        
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className={Styles.app}>
                <Chat/>
                <Header view={"/lab"} props={this.props}/>
                <div className={Styles.sectionTwo}>
                    <ProjectEqual
                        name={"Unite"}
                        title={"a resilience initiative"}
                        description={"Unite supports UAE SMEs with AI-powered automation and subsidized access to digital growth."}
                        large={"40%"}
                        medium={"45%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776636797/swedish%20tech%20mafia/Unite_Logotype_white_tzidip.svg"}
                        //website_link={"https://unite.ae"}
                        first_color={"#F0425E"}
                        second_color={"#C8102E"}
                    />
                    <ProjectOdd
                        name={"TRAVCO"}
                        title={"Data-driven Travel Solutions"}
                        description={"Travco transforms global travel into frictionless, data-driven journeys from intent to destination."}
                        large={"50%"}
                        medium={"50%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776632082/swedish%20tech%20mafia/Travco_Logotype_Inv_bv5dbz.svg"}
                        //website_link={"https://travco.ai"}
                        first_color={"#2A78E5"}
                        second_color={"#7BA1FD"}
                    />
                    <ProjectEqual
                        name={"TRADEBRITE"}
                        title={"fintech for sme"}
                        description={"Tradebrite is a Fintech company designed to bring professional settlement direct to small medium enterprises."}
                        large={"40%"}
                        medium={"50%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1660398523/swedish%20tech%20mafia/Tradebrite_Logotype_RGB_White_g55icf.png"}
                        first_color={"#5CC2FD"}
                        second_color={"#9DEBFC"}
                    />
                    <ProjectOdd
                        name={"Hotel Insider"}
                        title={"HOTEL SAVINGS REDEFINED"}
                        description={"Hotel Insider is an independent global online hotel and travel platform, powered by its own propriety technology and leading reward program."}
                        large={"40%"}
                        medium={"35%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776628194/swedish%20tech%20mafia/hi-logo_m9rch4.svg"}
                        first_color={"#FE7D06"}
                        second_color={"#FEC406"}
                    />
                    <ProjectEqual
                        name={"Simply Shop"}
                        title={"Your Shop Online"}
                        description={"Simply Shop is a ecommerce manager that enables anyone to deploy a mobile friendly shop to web and app in minutes."}
                        large={"45%"}
                        medium={"50%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776629795/swedish%20tech%20mafia/SimplyShop_Logotype_RGB_Inv_siodrb.svg"}
                        first_color={"#FF3E4A"}
                        second_color={"#FFB37D"}
                    />
                    <ProjectOdd
                        name={"Holaaa"}
                        title={"airport assistance anywhere"}
                        description={"Holaaa is a digital platform that enables travel agencies and greeting companies to instantly book airport greeters around the world."}
                        large={"40%"}
                        medium={"45%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776628194/swedish%20tech%20mafia/holaaa-logo_tctrqi.svg"}
                        first_color={"#00BDA7"}
                        second_color={"#B1E25B"}
                    />
                    <ProjectEqual
                        name={"YIELDLOCK"}
                        title={"YIELDLOCK ANY PROPERTY"}
                        description={"Yieldlock is a unique sale & leaseback framework facilitating value-added property transactions for all parties while minimizing risks."}
                        large={"50%"}
                        medium={"60%"}
                        small={"80%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1660398523/swedish%20tech%20mafia/YIELDLOCK_Logotype_RGB_Inv_gyqgsi.png"}
                        website_link={"https://app.yieldlock.com"}
                        first_color={"#1A3D4E"}
                        second_color={"#4C798E"}
                    />
                    <ProjectOdd
                        name={"YIELDSPOTTER"}
                        title={"SPOT YIELD DEALS"}
                        description={"Yieldspotter is the only dedicated portal for investors to spot high yield property investments offered exclusively with risk free income."}
                        large={"50%"}
                        medium={"60%"}
                        small={"80%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776629940/swedish%20tech%20mafia/YIELDSPOTTER_Logotype_RGB_White_NS_ig9rop.svg"}
                        website_link={"https://yieldspotter.com"}
                        first_color={"#C11A70"}
                        second_color={"#E44C9A"}
                    />
                    <ProjectEqual
                        name={"VICER"}
                        title={"Instant Services"}
                        description={"Vicer is a service aggregator offering integrated solutions for developers and owners associations to capitalize long-term. "}
                        large={"40%"}
                        medium={"45%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776630101/swedish%20tech%20mafia/Vicer_Logotype_Corporate_RGB_Wnite_ktitti.svg"}
                        first_color={"#41CBC7"}
                        second_color={"#00ECCC"}
                    />
                    <ProjectOdd
                        name={"Prettyclose"}
                        title={"Discover. Reserve. Share."}
                        description={"Prettyclose is a lifestyle platform focused on making travel and city life easier to discover, reserve and share with others."}
                        large={"40%"}
                        medium={"50%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776630209/swedish%20tech%20mafia/Prettyclose_RGB_White_sn4tas.svg"}
                        first_color={"#B9A24E"}
                        second_color={"#D6C482"}
                    />
                </div>
                <ContactForm/>
                <Footer props={this.props}/>
            </div>
        );
    }
}

/*
 <ProjectEqual
                        name={"PRIMEHIT"}
                        title={"Online Advertising Futurized"}
                        description={"Primehit strives to simplify and automate the way businesses advertise online, by bridging advantages of programmatic advertising with traditional know-how."}
                        large={"50%"}
                        medium={"50%"}
                        small={"70%"}
                        logo_link={"https://firebasestorage.googleapis.com/v0/b/stm-v1.appspot.com/o/Primehit_Inv.png?alt=media&token=6222a7d5-5318-48a2-b3ea-1b81b726681f"}
                        pitch_link={"https://firebasestorage.googleapis.com/v0/b/stm-v1.appspot.com/o/PH_PitchDeck_INT_19.03_SHORT.pdf?alt=media&token=f9dd4899-54c3-4206-b64f-571db9a6f660"}
                        video_link={"https://www.youtube.com/watch?v=ipResyecYHo&feature=youtu.be"}
                        website_link={"http://primehit.com"}
                        first_color={"#00A4DF"}
                        second_color={"#7ACFF4"}
                    />
 */

/*
<ProjectEqual
                        name={"simply shop"}
                        title={"Your Shop Online"}
                        description={"Simply Shop is a ecommerce manager that enables anyone to deploy a mobile friendly shop to web and app in minutes."}
                        large={"45%"}
                        medium={"50%"}
                        small={"70%"}
                        logo_link={"https://firebasestorage.googleapis.com/v0/b/stm-v1.appspot.com/o/simplyshop-logo.png?alt=media&token=246e7870-f05f-402d-a8d9-49a7fffbaa43"}
                        first_color={"#FF3E4A"}
                        second_color={"#FFB37D"}
                    />
 */

/*
<ProjectEqual
                        name={"VICER"}
                        title={"Instant Services"}
                        description={"Vicer is a service aggregator offering integrated solutions for developers and owners associations to capitalize long-term. "}
                        large={"40%"}
                        medium={"45%"}
                        small={"70%"}
                        logo_link={"https://firebasestorage.googleapis.com/v0/b/stm-v1.appspot.com/o/vicer-logo.svg?alt=media&token=1c4318d8-0b25-4e34-af85-c9a85e4f6bd1"}
                        pitch_link={"https://firebasestorage.googleapis.com/v0/b/stm-v1.appspot.com/o/V_PitchDeck_18.03_SHORT.pdf?alt=media&token=0b3cf17a-ab0b-4481-b1e0-f0047b19207c"}
                        first_color={"#DE007D"}
                        second_color={"#FF9BCB"}
                    />
 */

export default Lab;


// WEBPACK FOOTER //
// ./src/pages/lab/component.js